import React from "react";
import HelpIcon from "@material-ui/icons/Help";

import HeaderPageItem from "../../../../custom/HeaderPageItem";
import { Box, Divider, makeStyles, Typography } from "@material-ui/core";
import SectionTitle from "../HelpDialog/SectionTitle";
import { FormattedHTMLMessage, FormattedMessage } from "react-intl";
import TipBox from "../../TipBox";
import ActionDialog from "../../ActionDialog";
import IconInfoOutlined from "@material-ui/icons/InfoOutlined";
import IconPersonOutline from "@material-ui/icons/PersonOutline";
import IconPerson from "@material-ui/icons/Person";
import IconGroup from "@material-ui/icons/Group";
import HelpSharpIcon from "@material-ui/icons/HelpSharp";
import TableChartIcon from "@material-ui/icons/TableChart";
import NotesSharpIcon from "@material-ui/icons/NotesSharp";

const useStyles = makeStyles((theme) => ({
  divider: {
    borderBottom: `1px solid ${theme.palette.divider}`,
  },
  flexContainer: {
    display: "flex",
    gap: theme.spacing(1),
    alignItems: "center",
    marginBottom: theme.spacing(1),
  },
  infoIcon: {
    color: "green",
  },
  marginTop: {
    marginTop: theme.spacing(1),
  },
}));

const commissions = ["BONUS", "BONUS_MANAGER", "BONUS_LEADERSHIP_ONE_TIME", "BONUS_MANAGER_SPLIT", "BONUS_RECOMMENDANT", "BONUS_SPLIT"];

const HeaderManagersAndAgents = ({ onBack }) => {
  const classes = useStyles();
  const [open, setOpen] = React.useState(false);
  return (
    <>
      <HeaderPageItem
        title="app.report.hierarchical"
        onBack={onBack}
        onMore={() => setOpen(true)}
        IconMore={HelpIcon}
      />
      <ActionDialog
        open={open}
        title="app.report.hierarchical"
        onClose={() => setOpen(false)}
        maxWidth="md"
        enableConfirmButton={false}
      >
        <Typography paragraph>
          <FormattedMessage id="app.report.hierarchical.description" />
        </Typography>

        <Typography
          className={classes.divider}
          paragraph
        >
          <FormattedMessage id="app.report.hierarchical.structure" />
        </Typography>

        <SectionTitle icon={HelpSharpIcon}>
          <FormattedMessage id="app.report.manager.howToUse.title" />
        </SectionTitle>

        <Typography paragraph>
          <FormattedMessage id="app.report.hierarchical.userInfo" />
        </Typography>

        <Box
          className={classes.flexContainer}
          ml={4}
        >
          <IconGroup
            fontSize="small"
            color="primary"
          />
          <Typography variant="subtitle1">
            <FormattedMessage id="app.report.hierarchical.userInfo.leadership" />
          </Typography>
        </Box>

        <Box
          className={classes.flexContainer}
          ml={4}
        >
          <IconGroup fontSize="small" />
          <Typography variant="body1">
            <FormattedMessage id="app.report.hierarchical.userInfo.manager" />
          </Typography>
        </Box>
        <Box
          className={classes.flexContainer}
          ml={4}
        >
          <IconPerson fontSize="small" />
          <Typography variant="body1">
            <FormattedMessage id="app.report.hierarchical.userInfo.agent" />
          </Typography>
        </Box>
        <Box
          className={classes.flexContainer}
          ml={4}
          pb={2}
        >
          <IconPersonOutline fontSize="small" />
          <Typography variant="body1">
            <FormattedMessage id="app.report.hierarchical.userInfo.customer" />
          </Typography>
        </Box>
        <Typography paragraph>
          <FormattedHTMLMessage id="app.report.hierarchical.userInfo.agreementStatus" />
        </Typography>
        <Typography paragraph>
          <FormattedHTMLMessage id="app.report.hierarchical.actions" />
        </Typography>
        <Typography paragraph>
          <FormattedHTMLMessage id="app.report.hierarchical.expand" />
        </Typography>
        <Typography paragraph>
          <FormattedHTMLMessage id="app.report.hierarchical.infoIconHint" />
        </Typography>
        <Typography paragraph>
          <FormattedHTMLMessage id="app.report.hierarchical.contractIndicator" />
        </Typography>
        <Typography paragraph>
          <FormattedHTMLMessage id="app.report.hierarchical.grouping" />
        </Typography>

        <TipBox>
          <FormattedMessage id="app.report.hierarchical.tip.grouping" />
        </TipBox>

        <TipBox>
          <FormattedMessage id="app.report.hierarchical.tip.buttons" />
        </TipBox>

        <Divider className={classes.marginTop} />

        <SectionTitle
          icon={() => (
            <IconInfoOutlined
              className={classes.infoIcon}
              fontSize="small"
            />
          )}
        >
          <FormattedMessage id="app.report.hierarchical.infoIcon.title" />
        </SectionTitle>

        <Typography paragraph>
          <FormattedMessage id="app.report.hierarchical.infoIcon.description" />
        </Typography>

        <Typography paragraph>
          <FormattedMessage id="app.report.hierarchical.infoIcon.header" />
        </Typography>

        <Typography paragraph>
          <FormattedMessage id="app.report.hierarchical.values.sections" />
        </Typography>

        <Typography paragraph>
          <FormattedHTMLMessage id="app.report.hierarchical.values.contractEarnings" />
        </Typography>

        <Typography paragraph>
          <FormattedHTMLMessage id="app.report.hierarchical.values.receivedCommissions" />
        </Typography>

        <Typography paragraph>
          <FormattedHTMLMessage id="app.report.hierarchical.values.generatedCommissions" />
        </Typography>

        <Typography paragraph>
          <FormattedHTMLMessage id="app.report.hierarchical.values.commissionTypes" />
        </Typography>

        <Typography paragraph>
          <FormattedHTMLMessage id="app.report.hierarchical.values.relationship" />
        </Typography>

        {commissions.map((commission) => {
          const isLastOption = commission === commissions[commissions.length - 1];

          return (
            <Typography
              paragraph
              key={commission}
              className={isLastOption ? classes.divider : undefined}
            >
              <strong>
                <FormattedMessage id={`app.commission.type.${commission}`} />
              </strong>
              {": "}
              <FormattedMessage id={`app.commission.type.${commission}.description`} />
            </Typography>
          );
        })}

        <SectionTitle icon={NotesSharpIcon}>
          <FormattedMessage id="app.report.hierarchical.values.note" />
        </SectionTitle>

        <Typography paragraph>
          <FormattedMessage id="app.report.hierarchical.values.note.currentConfig" />
        </Typography>
        <Typography paragraph>
          <strong>
            <FormattedMessage id="app.report.hierarchical.values.note.exampleLabel" />
          </strong>
          <FormattedMessage id="app.report.hierarchical.values.note.example" />
        </Typography>
        <Typography paragraph>
          <FormattedMessage id="app.report.hierarchical.values.note.changes" />
        </Typography>
        <Typography paragraph>
          <FormattedMessage id="app.report.hierarchical.values.note.dynamic" />
        </Typography>
        <Typography
          paragraph
          className={classes.divider}
        >
          <FormattedMessage id="app.report.hierarchical.values.note.divergence" />
        </Typography>

        <SectionTitle icon={TableChartIcon}>
          <FormattedMessage id="app.report.hierarchical.contractTable.title" />
        </SectionTitle>

        <Typography paragraph>
          <FormattedMessage id="app.report.hierarchical.contractTable.description" />
        </Typography>

        <Typography paragraph>
          <FormattedMessage id="app.report.hierarchical.contractTable.commissionInfo" />
        </Typography>
      </ActionDialog>
    </>
  );
};

export default HeaderManagersAndAgents;
